import React, { useState } from 'react';
import { devAPI } from '@/lib/api';
import { Play } from 'lucide-react';

const ENDPOINTS = [
  { label: 'GET /v1/users', method: 'GET', path: '/users', body: '' },
  { label: 'POST /v1/users', method: 'POST', path: '/users', body: '{\n  "email": "test@example.com"\n}' },
  { label: 'POST /v1/tokens/validate', method: 'POST', path: '/tokens/validate', body: '{\n  "token": "<access_token>"\n}' },
  { label: 'GET /v1/events', method: 'GET', path: '/events', body: '' },
  { label: 'GET /v1/webhooks', method: 'GET', path: '/webhooks', body: '' },
];

export default function PlaygroundPage() {
  const [sel, setSel] = useState(0);
  const [body, setBody] = useState(ENDPOINTS[0].body);
  const [resp, setResp] = useState<any>(null);
  const [busy, setBusy] = useState(false);
  const ep = ENDPOINTS[sel];

  const pick = (i: number) => { setSel(i); setBody(ENDPOINTS[i].body); setResp(null); };
  const run = async () => {
    setBusy(true);
    try {
      const parsed = body.trim() ? JSON.parse(body) : undefined;
      setResp(await devAPI.playground(ep.method, ep.path, parsed));
    } catch (e: any) {
      setResp({ status: 0, body: { error: e.message } });
    } finally {
      setBusy(false);
    }
  };

  const snippet = `curl -X ${ep.method} https://api.dev.auth.isaacmccourt.dev/v1${ep.path} \\
  -H "Authorization: Bearer sk_live_<your key>"${ep.method !== 'GET' && body.trim() ? ` \\\n  -H "Content-Type: application/json" \\\n  -d '${body.replace(/\n\s*/g, ' ')}'` : ''}`;

  return (
    <div className="p-6 max-w-4xl">
      <h1 className="text-2xl font-bold text-gray-900 mb-1">Playground</h1>
      <p className="text-gray-600 mb-6">Try the developer API live (runs through your portal session). The snippet shows the equivalent call with a real secret key.</p>
      <div className="flex flex-wrap gap-2 mb-4">
        {ENDPOINTS.map((e, i) => <button key={i} onClick={() => pick(i)} className={`px-3 py-1.5 rounded-md text-sm ${i === sel ? 'bg-blue-600 text-white' : 'bg-white border border-gray-200'}`}>{e.label}</button>)}
      </div>
      {ep.method !== 'GET' && (
        <textarea value={body} onChange={(e) => setBody(e.target.value)} rows={5} className="w-full border border-gray-300 rounded-md px-3 py-2 font-mono text-sm mb-3" />
      )}
      <button onClick={run} disabled={busy} className="bg-blue-600 text-white px-4 py-2 rounded-md flex items-center mb-4"><Play className="w-4 h-4 mr-2" />{busy ? 'Running…' : 'Send'}</button>
      {resp && (
        <div className="mb-4">
          <p className="text-sm font-medium mb-1">Response <span className={`text-xs ${resp.status < 300 ? 'text-green-600' : 'text-red-600'}`}>HTTP {resp.status}</span></p>
          <pre className="bg-gray-900 text-gray-100 rounded-lg p-4 text-sm overflow-auto">{JSON.stringify(resp.body, null, 2)}</pre>
        </div>
      )}
      <p className="text-sm font-medium mb-1">Equivalent request</p>
      <pre className="bg-gray-100 rounded-lg p-4 text-sm overflow-auto whitespace-pre-wrap">{snippet}</pre>
    </div>
  );
}
